module.exports = __webpack_public_path__ + "img/恭喜您獲得.0300a6de.png";